/**
 * Resolve nested key like "header.logout".
 * @param {Record<string, unknown>} dict
 * @param {string} key
 * @returns {string | undefined}
 */
function resolveKey(dict, key) {
  const parts = key.split(".");
  let current = /** @type {unknown} */ (dict);
  for (const part of parts) {
    if (!current || typeof current !== "object") return undefined;
    current = /** @type {Record<string, unknown>} */ (current)[part];
  }
  return typeof current === "string" ? current : undefined;
}

/**
 * @param {Record<string, Record<string, unknown>>} dictionaries
 * @param {(key: string, lang: string) => void} [onMissingKey]
 * @returns {(key: string, fallback?: string, lang?: string) => string}
 */
export function createTranslator(dictionaries, onMissingKey) {
  return function t(key, fallback, lang) {
    const activeLang = lang || "fr";
    const dict = dictionaries[activeLang] || dictionaries.fr || {};
    const value = resolveKey(dict, key);
    if (value !== undefined) return value;
    if (activeLang !== "fr" && dictionaries.fr) {
      const frValue = resolveKey(dictionaries.fr, key);
      if (frValue !== undefined) return frValue;
    }
    if (onMissingKey) onMissingKey(key, activeLang);
    return fallback ?? key;
  };
}
